<template>
  <v-dialog v-model="show" width="500" color="white">
    <v-card class="dialog">
      <div>
        <v-flex xs12 sm12 md12 lg12 d-flex class="padding-20">
          <v-flex v-if="icon" md4 class="icon">
            <img :src="require(`./../../assets/${icon}`)" />
          </v-flex>
          <v-flex md8>
            <v-card-title class="pa-0 pt-2 title white--text font-weight-bold">{{header}}</v-card-title>
            <div v-if="contents.length > 0">
              <div v-for="(con, index) in contents" :key="index">
                <v-card-text v-if="typeof con == 'string'" class="pa-0 pt-3 subheading white--text font-weight-light">{{con}}</v-card-text>
                <v-text-field v-else :type="con.type" v-model="fieldModel[con.param]" :label="con.label" class="pa-0 pt-3 input-field" single-line
                outline required></v-text-field>              
              </div>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-flex>
        </v-flex>
        <v-flex class="button-alignment">
          <div class="d-flex">
            <div v-for="act in actions" :key="`${act.context}`">
              <div v-if="act.type == 'button'">
                <v-btn :color="act.color" @click="responseHandler(act.context)">
                  {{act.label}}
                </v-btn>
              </div>
            </div>
          </div>
        </v-flex>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import {
    EventBus
  } from '@/services/event-bus';
  
  export default {
    props: {
      reference: String,
      data: {
        type: Object,
        default: function() {
          return {}
        }
      },
      visible: Boolean,
      header: {
        type: String,
        default: ''
      },
      contents: Array,
      icon: {
        type: String,
        default: ''
      },
      actions: {
        type: Array,
        default: function() { 
          return [] 
        }
      }
    },
    data() {
      return {
        fieldModel: {},
        show: false
      }
    },
    mounted() {
      this.show = this.visible;
      this.fieldModel = Object.assign({}, this.init())
    },
    methods: {
      init() {
        function defaultValue(type) {
          switch (type) {
            case 'number':
              return 0
            case 'boolean':
              return false
            case 'text':
            case 'password':
            case 'email':
            default:
              return ''
          }
        }
        function extractData(component) {
           if (this.data && this.data[component.param]) { 
             this.data[component.param]
           } else {
             return defaultValue(component.type)
           }
        }

        let dataState = extractData.bind(this)
        const obj = {}
        this.fields.forEach(component => {
          obj[component.param] = dataState(component) 
        })
        return obj
      },
      responseHandler(context) {
        // Checking if it is an Input field
        const isInput = this.contents.some(el =>  typeof el === 'object')
        const response = {
          context,
          ref: this.reference,
          value: []
        }
        if(isInput) {
          response['value'].push(this.fieldModel)
        }
        EventBus.$emit('dialogResponse', response)
        this.fieldModel = {}
        this.show = false
      }
    },
    watch: {
      visible(val) {
        this.show = val;
      }
    }
  }
</script>

<style scoped>
  .dialog {
    border-radius: 8px;
    background-color: white;
  }

  .padding-20 {
    padding: 20px;
  }

  .button-alignment {
    display: flex;
    justify-content: flex-end;
    padding: 0 20px 20px;
  }

  .d-flex {
    display: flex;
  }

  .icon {
    display: grid;
    place-items: center;

  }

  .icon img {
    height: 100px;
  }
</style>
